module.exports = __webpack_public_path__ + "static/media/box.ac5e4e86.png";